import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Code, Zap, Shield, Webhook, AlertCircle } from 'lucide-react';
import { DocsLayout } from '../../components/docs/DocsLayout';
export function DocsHomePage() {
  return <DocsLayout data-id="element-1221">
      <div className="py-12" data-id="element-1222">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-16" data-id="element-1223">
          <h1 className="text-5xl font-bold text-slate-900 mb-4" data-id="element-1224">
            Obseq Documentation
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-1225">
            Everything you need to integrate global money infrastructure into
            your platform.
          </p>
        </motion.div>

        {/* Primary Tiles */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-1226">
          <motion.a href="#/docs/guides" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="group bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl p-8 hover:border-blue-400 hover:shadow-lg transition-all" data-id="element-1227">
            <BookOpen className="w-12 h-12 text-blue-600 mb-4" data-id="element-1228" />
            <h2 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-1229">
              Guides
            </h2>
            <p className="text-slate-600" data-id="element-1230">
              Step-by-step tutorials covering authentication, webhooks, error
              handling, and more.
            </p>
          </motion.a>

          <motion.a href="#/docs/api-reference" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="group bg-gradient-to-br from-slate-50 to-slate-100 border-2 border-slate-200 rounded-xl p-8 hover:border-slate-400 hover:shadow-lg transition-all" data-id="element-1231">
            <Code className="w-12 h-12 text-slate-600 mb-4" data-id="element-1232" />
            <h2 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-slate-600 transition-colors" data-id="element-1233">
              API Reference
            </h2>
            <p className="text-slate-600" data-id="element-1234">
              Complete reference for all Obseq APIs with request/response
              examples.
            </p>
          </motion.a>
        </div>

        {/* Popular Links */}
        <div className="mb-16" data-id="element-1235">
          <h3 className="text-lg font-semibold text-slate-900 mb-6" data-id="element-1236">
            Popular Topics
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1237">
            {[{
            icon: Zap,
            label: 'Getting Started',
            href: '/docs/guides/getting-started'
          }, {
            icon: Shield,
            label: 'Authentication',
            href: '/docs/guides/authentication'
          }, {
            icon: Webhook,
            label: 'Webhooks',
            href: '/docs/guides/webhooks'
          }, {
            icon: AlertCircle,
            label: 'Errors',
            href: '/docs/guides/errors'
          }, {
            icon: Code,
            label: 'Idempotency',
            href: '/docs/guides/idempotency'
          }, {
            icon: BookOpen,
            label: 'Pagination',
            href: '/docs/guides/pagination'
          }].map((link, index) => <motion.a key={link.href} href={`#${link.href}`} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3 + index * 0.05
          }} className="group flex items-center gap-3 p-4 bg-white border border-slate-200 rounded-lg hover:border-blue-300 hover:shadow-md transition-all" data-id="element-1238">
                <link.icon className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" data-id="element-1239" />
                <span className="text-sm font-medium text-slate-700 group-hover:text-slate-900" data-id="element-1240">
                  {link.label}
                </span>
              </motion.a>)}
          </div>
        </div>

        {/* Footer Links */}
        <div className="flex items-center justify-center gap-6 text-sm text-slate-600" data-id="element-1241">
          <a href="#/docs/support" className="hover:text-slate-900 transition-colors" data-id="element-1242">
            Support
          </a>
          <span data-id="element-1243">•</span>
          <a href="#" className="hover:text-slate-900 transition-colors" data-id="element-1244">
            API Status
          </a>
          <span data-id="element-1245">•</span>
          <a href="#" className="hover:text-slate-900 transition-colors" data-id="element-1246">
            Changelog
          </a>
        </div>
      </div>
    </DocsLayout>;
}